export default __webpack_public_path__ + "static/media/placeholder_store05-nl-mobile.15ce631a.png";